DR.blog = DR.blog || {};
DR.blog.struct = DR.blog.struct || {};
DR.blog.select = DR.blog.select || {};
/** @extends {DR._Base} */
DR.blog.struct.Author = function(par){
	/** @private */
	this._t = 1302;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
};
DR._Base._types[1302] = DR.blog.struct.Author;
DR.blog.struct.Author[__P] = new DR._Base;
DR.blog.struct.Author[__P][__C] = DR.blog.struct.Author;
/** @type {Number} */
DR.blog.struct.Author.prototype.id = null;
/** @type {DR.roadgames.struct.Image} */
DR.blog.struct.Author.prototype.image = null;
/** @type {String} */
DR.blog.struct.Author.prototype.name = null;
 
/** @extends {DR._Select} */
DR.blog.select.Author = function(){
	this._fields = {};
};
DR.blog.select.Author[__CL] = "Blog__Author";
DR.blog.select.Author[__P] = new DR._Select;
DR.blog.select.Author[__P][__C] = DR.blog.select.Author;
/** @param {boolean} [v]
  * @return {DR.blog.select.Author} */
DR.blog.select.Author.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Author} */
DR.blog.select.Author.prototype.image = function(v){ this._fields.image = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Author} */
DR.blog.select.Author.prototype.name = function(v){ this._fields.name = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.blog.struct.QAItem = function(par){
	/** @private */
	this._t = 1321;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.answer)) this.answer = String(par.answer||'');
	if(DR._Base.is(par.question)) this.question = String(par.question||'');
};
DR._Base._types[1321] = DR.blog.struct.QAItem;
DR.blog.struct.QAItem[__P] = new DR._Base;
DR.blog.struct.QAItem[__P][__C] = DR.blog.struct.QAItem;
/** @type {String} */
DR.blog.struct.QAItem.prototype.answer = null;
/** @type {String} */
DR.blog.struct.QAItem.prototype.question = null;
 
/** @extends {DR._Base} */
DR.blog.struct.Item = function(par){
	/** @private */
	this._t = 1294;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.author)) this.author = DR._Base.cast(par.author);
	if(DR._Base.is(par.cover)) this.cover = DR._Base.cast(par.cover);
	if(DR._Base.is(par.coverAltText)) this.coverAltText = String(par.coverAltText||'');
	if(DR._Base.is(par.hasCover)) this.hasCover = Boolean(par.hasCover);
	if(DR._Base.is(par.html)) this.html = String(par.html||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.intro)) this.intro = String(par.intro||'');
	if(DR._Base.is(par.lang)) this.lang = String(par.lang||'');
	if(DR._Base.is(par.metaDescription)) this.metaDescription = String(par.metaDescription||'');
	if(DR._Base.is(par.metaTitle)) this.metaTitle = String(par.metaTitle||'');
	if(DR._Base.is(par.pubDate)) this.pubDate = (parseInt(par.pubDate)||0);
	if(DR._Base.is(par.qa)){
		var tmp = [];
		for( var k in par.qa ) tmp.push(DR._Base.cast(par.qa [k]));
		this.qa = tmp;
	}
	if(DR._Base.is(par.tags)){
		var tmp = [];
		for( var k in par.tags ) tmp.push(String(par.tags [k]||''));
		this.tags = tmp;
	}
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1294] = DR.blog.struct.Item;
DR.blog.struct.Item[__P] = new DR._Base;
DR.blog.struct.Item[__P][__C] = DR.blog.struct.Item;
/** @type {DR.blog.struct.Author} */
DR.blog.struct.Item.prototype.author = null;
/** @type {DR.roadgames.struct.Pic} */
DR.blog.struct.Item.prototype.cover = null;
/** @type {String|null} */
DR.blog.struct.Item.prototype.coverAltText = null;
/** @type {Boolean} */
DR.blog.struct.Item.prototype.hasCover = null;
/** @type {String} */
DR.blog.struct.Item.prototype.html = null;
/** @type {Number} */
DR.blog.struct.Item.prototype.id = null;
/** @type {String} */
DR.blog.struct.Item.prototype.intro = null;
/** @type {String} */
DR.blog.struct.Item.prototype.lang = null;
/** @type {String|null} */
DR.blog.struct.Item.prototype.metaDescription = null;
/** @type {String|null} */
DR.blog.struct.Item.prototype.metaTitle = null;
/** @type {Number} */
DR.blog.struct.Item.prototype.pubDate = null;
/** @type {Array.<DR.blog.struct.QAItem>} */
DR.blog.struct.Item.prototype.qa = null;
/** @type {Array.<String>} */
DR.blog.struct.Item.prototype.tags = null;
/** @type {String} */
DR.blog.struct.Item.prototype.title = null;
/** @type {String} */
DR.blog.struct.Item.prototype.url = null;
 
/** @extends {DR._Select} */
DR.blog.select.Item = function(){
	this._fields = {};
};
DR.blog.select.Item[__CL] = "Blog__Item";
DR.blog.select.Item[__P] = new DR._Select;
DR.blog.select.Item[__P][__C] = DR.blog.select.Item;
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.author = function(v){ this._fields.author = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.cover = function(v){ this._fields.cover = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.coverAltText = function(v){ this._fields.coverAltText = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.hasCover = function(v){ this._fields.hasCover = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.html = function(v){ this._fields.html = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.intro = function(v){ this._fields.intro = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.lang = function(v){ this._fields.lang = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.metaDescription = function(v){ this._fields.metaDescription = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.metaTitle = function(v){ this._fields.metaTitle = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.pubDate = function(v){ this._fields.pubDate = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.qa = function(v){ this._fields.qa = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.tags = function(v){ this._fields.tags = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.title = function(v){ this._fields.title = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.blog.select.Item} */
DR.blog.select.Item.prototype.url = function(v){ this._fields.url = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.blog.struct.ItemsList = function(par){
	/** @private */
	this._t = 1295;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.count)) this.count = (parseInt(par.count)||0);
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
	if(DR._Base.is(par.pgs)) this.pgs = (parseInt(par.pgs)||0);
};
DR._Base._types[1295] = DR.blog.struct.ItemsList;
DR.blog.struct.ItemsList[__P] = new DR._Base;
DR.blog.struct.ItemsList[__P][__C] = DR.blog.struct.ItemsList;
/** @type {Number} */
DR.blog.struct.ItemsList.prototype.count = null;
/** @type {Array.<DR.blog.struct.Item>} */
DR.blog.struct.ItemsList.prototype.items = null;
/** @type {Number} */
DR.blog.struct.ItemsList.prototype.pgs = null;
 
/** @extends {DR._Method} */
DR.blog.GetItem = function(par){
	this.select = [];
	/** @private */
	this._t = 1297;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1297] = DR.blog.GetItem;
DR.blog.GetItem[__CL] = "Blog__GetItem";
DR.blog.GetItem[__P] = new DR._Method;
DR.blog.GetItem[__P][__C] = DR.blog.GetItem;
/** @type {Number} */
DR.blog.GetItem.prototype.id = null;
/** @type {DR.blog.struct.Item} */
DR.blog.GetItem.prototype.re = null;
 
/** @extends {DR._Method} */
DR.blog.GetItems = function(par){
	this.select = [];
	/** @private */
	this._t = 1296;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1296] = DR.blog.GetItems;
DR.blog.GetItems[__CL] = "Blog__GetItems";
DR.blog.GetItems[__P] = new DR._Method;
DR.blog.GetItems[__P][__C] = DR.blog.GetItems;
/** @type {Number} */
DR.blog.GetItems.prototype.count = null;
/** @type {Number} */
DR.blog.GetItems.prototype.pg = null;
/** @type {DR.blog.struct.ItemsList} */
DR.blog.GetItems.prototype.re = null;
 
/** @extends {DR._Method} */
DR.blog.GetRelated = function(par){
	this.select = [];
	/** @private */
	this._t = 1298;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1298] = DR.blog.GetRelated;
DR.blog.GetRelated[__CL] = "Blog__GetRelated";
DR.blog.GetRelated[__P] = new DR._Method;
DR.blog.GetRelated[__P][__C] = DR.blog.GetRelated;
/** @type {Number} */
DR.blog.GetRelated.prototype.id = null;
/** @type {DR.blog.struct.ItemsList} */
DR.blog.GetRelated.prototype.re = null;
 
D.loaded();